import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getLegalDocumentAPI, LegalDocument, LegalDocumentType } from "../services/api/legal";

export const useLegalDocument = (type: LegalDocumentType) => {
  const { i18n } = useTranslation();
  const [doc, setDoc] = useState<LegalDocument | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<boolean>(false);

  useEffect(() => {
    let isMounted = true;
    const locale = (i18n.language || "en").startsWith("zh") ? "zh_hant" : "en";
    setLoading(true);
    setError(false);
    getLegalDocumentAPI(type, locale)
      .then((res: any) => {
        if (!isMounted) return;
        if (res?.status === 0 && res?.result) {
          setDoc(res.result);
        } else {
          setDoc(null);
          setError(true);
        }
      })
      .catch(() => {
        if (!isMounted) return;
        setDoc(null);
        setError(true);
      })
      .finally(() => {
        if (isMounted) setLoading(false);
      });
    return () => {
      isMounted = false;
    };
  }, [type, i18n.language]);

  return { doc, loading, error };
};
